import { render, staticRenderFns } from "./guideShopshelf.vue?vue&type=template&id=bcacbfba"
import script from "./guideShopshelf.vue?vue&type=script&lang=js"
export * from "./guideShopshelf.vue?vue&type=script&lang=js"
import style0 from "./guideShopshelf.vue?vue&type=style&index=0&id=bcacbfba&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports